import { getWeixin } from '../api'
import { Toast, Indicator  } from 'mint-ui';
import it from "element-ui/src/locale/lang/it";
export function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    if(query.indexOf('?')>0) {
       query.split('?')[1]
    }
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

// 微信初始化
export function weixinInit(state) {
    getWeixin({
        state: state,
		    url: location.href
    })
    .then(res=>{
        const cfg = res.data;
        wx.config({
            debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: cfg.appId, // 必填，公众号的唯一标识
            timestamp: cfg.timestamp, // 必填，生成签名的时间戳
            nonceStr: cfg.noncestr, // 必填，生成签名的随机串
            signature: cfg.signature,// 必填，签名
            jsApiList: ['chooseWXPay','scanQRCode','openLocation'] // 必填，需要使用的JS接口列表
        });
    })
}

/**
 * 姓名脱敏
 * @param name
 * @returns {string}
 */
export function formatName(name) {
  var newStr = '';
  if(name) {
    if (name.length == 2) {
      newStr = name.substr(0, 1) + '*';
    } else if (name.length > 2) {
      var char = '';
      for (var i = 0, len = name.length - 2; i < len; i++) {
        char += '*';
      }
      newStr = name.substr(0, 1) + char + name.substr(-1, 1);
    } else {
      newStr = name;
    }
  }
  return newStr;
}

/**
 * 身份证脱敏
 * @param name
 * @returns {string}
 */
export function formatNumber(name, qNumber,hNumber) {
  var newStr = '';
  if(!qNumber) {
    qNumber = 3
  }
  if(!hNumber) {
    hNumber = 4
  }
  if(name) {
    if (name.length == 2) {
      newStr = name.substr(0, 1) + '*';
    } else if (name.length > 2) {
      var char = '';
      for (var i = 0, len = name.length - qNumber-hNumber; i < len; i++) {
        char += '*';
      }
      newStr = name.substr(0, qNumber) + char + name.substr(-hNumber, hNumber);
    } else {
      newStr = name;
    }
  }
  return newStr;
}

/**
 * 判断业务受理时限
 * @param type
 */
export function validSlsx(type) {
  if(sessionStorage.getItem(type)=='true') {
    return true
  } else {
    Toast(`超过业务受理时间`);
    return false
  }
}

/**
 * 生成楼号、房间号、单元号
 * @param type
 */
export function getLh(type,num,dw) {
  let arr = []
  // 楼层从-2开始
  if(type == 'lc') {
    arr.push({label: '-2' + dw,value: '-2'})
    arr.push({label: '-1' + dw,value: '-1'})
  }
  for(let i= 0;i<num;i++) {
    let item = i+1
    if(i<9) {
      item = '0'+ item
    }
    if(type=='lh') {
      item+='#'
    }
    arr.push({
      label: item + dw,
      value: item
    })
  }
  return arr
}

export function isCnNewID (rule, value, callback) {
  var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
  var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
  if (/^\d{17}\d|x$/i.test(value)) {
    var sum = 0, idx;
    for (var i = 0; i < value.length - 1; i++) {
      // 对前17位数字与权值乘积求和
      sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
    }
    // 计算模（固定算法）
    idx = sum % 11;
    console.log(arrValid[idx])
    // 检验第18为是否与校验码相等
    if (arrValid[idx] == value.substr(17, 1).toUpperCase()) {
      callback()
    } else {
      callback("身份证格式有误")
    }
  } else {
    callback("身份证格式有误")
  }
}

/* 是否手机号码*/
export function validatePhone(rule, value, callback) {
  const reg = /^[1][0-9]{10}$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的电话号码'));
    } else {
      callback();
    }
  }
}

/**
 * 转file
 * @param dataurl
 * @returns {Blob}
 */
export function dataURLtoFilename(dataurl,filename) {
  let arr = dataurl.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  // suffix是该文件的后缀
  let suffix = mime.split('/')[1];
  // atob 对经过 base-64 编码的字符串进行解码
  let bstr = atob(arr[1]);
  // n 是解码后的长度
  let n = bstr.length;
  // Uint8Array 数组类型表示一个 8 位无符号整型数组 初始值都是 数子0
  let u8arr = new Uint8Array(n);
  // charCodeAt() 方法可返回指定位置的字符的 Unicode 编码。这个返回值是 0 - 65535 之间的整数
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  // new File返回File对象 第一个参数是 ArraryBuffer 或 Bolb 或Arrary 第二个参数是文件名
  // 第三个参数是 要放到文件中的内容的 MIME 类型
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime,
  });
}




// WEBPACK FOOTER //
// ./src/utils/index.js